// @flow
import { esteroStreamUrl } from './conf'
import Event from './Event'
import Auth from './Auth'

/**
 * Socket for receiving data and setting up filters in Estero.
 * @function
 * @namespace Estero
 * @version 1.0.0
 * @description
 * The estero-socket is used to setup an updating subscription to estero. It can be modified on the fly by sending new EsteroSubscription objects and
 * it will supply Cuesta with a stream of updates.
 * @return { Object } Exposes `on`, `off` methods to subscribe to the events described above and `remove` to close the socket connection as well.
 */

/**
 * Represents Paging definition.
 * @memberof Estero
 */
type EsteroPaging = {
  page: number,
  pageSize: number
}

/**
 * Represents a subscription for Estero (list of Manatees)
 * @memberof Estero
 */
type EsteroSubscription = {
  filter: string,
  paging?: EsteroPaging,
  sortBy: string
}

/**
 * Represents an estero-socket.
 * @typedef { Object } Estero

 * @memberof EsteroSocket
 */
type EsteroSocket = {
  on(name: string, method: Function): void,
  off(name: string, method: Function): void,
  update(subscription: EsteroSubscription): void,
  remove(): void
}

export default (): EsteroSocket => {
  const event = new Event()
  const ws = new WebSocket(esteroStreamUrl + '?token=' + Auth.getToken())

  const remove = () => (ws.close(), event.reset())

  ws.onopen = () => {
    event.emit('open', {})
  }
  ws.onclose = msg => {
    event.emit('close', msg)
  }
  ws.onerror = err => {
    event.emit('error', err)
  }
  ws.onmessage = (msg: any) => {
    const data = JSON.parse(msg.data)
    event.emit('message', data)
  }

  const update = (subscription: EsteroSubscription) => {
    ws.send(JSON.stringify(subscription))
  }

  return {
    on: event.on,
    off: event.off,
    remove,
    update
  }
}
